import { render, staticRenderFns } from "./AutoRegistration.vue?vue&type=template&id=6528a620&"
import script from "./AutoRegistration.vue?vue&type=script&lang=js&"
export * from "./AutoRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports